import { FilterKey } from '@tokyojob/core'

export const FilterNameMap: Record<FilterKey, string> = {
  [FilterKey.visa]: 'visaType',
  [FilterKey.location]: 'location',
  [FilterKey.category]: 'jobCategory',
  [FilterKey.contract]: 'multiOption.contractType',
  [FilterKey.japanese]: 'japaneseLevel',
}
